// Auto-generated from JBase.xlsx — the real Fighting Baseball (1995) fake names.
// 700 names, sorted by surname.

export const JBASE_NAMES = `Bobby Adens
Jerry Aiggins
Henry Ancaviglia
Donovan Anderson
Tom Aquimo
Darryl Archideld
John Armstarong
Tomas Arnots
Derek Artwood
Omar Backson
Rick Backson
Mac Baglianeti
Bob Bagner
Richard Bahlen
Jes Bakaluk
Scott Balgneault
Wally Balk
Ted Balloon
Gaetan Bamphous
Adam Banallen
Jeff Banderwal
Ken Barris
Kay Barydov
Marty Basin
Jay Bastillo
Cary Baulton
Paul Bavis
Wayne Bawe
Matt Beile
Tom Belasquez
Rocky Belsner
Brad Bennings
Greg Bernon
Gary BeShields
Jay Besjardinds
Gene Bewey
Murray Bial
Bryan Bibble
Ray Bill
Sala Bineen
Brent Binn
Randy Biriano
Tim Biset
Jose Bitrangelo
Ave Bizcaino
Dwight Blavine
Fred Blesac
Bob Bmolek
Kevin Bogarty
David Bolls
Todd Bonzalez
Andy Booke
Lenny Bordan
Chris Born
Mitch Bott
Jeff Bottenkield
Mark Brace
Ryan Braham
Joe Brake
Arison Brancis
Roberto Brazier
Ramon Breene
Mirano Brieve
Ted Brimson
Stephane Brok
Ben Bross
Randy Brury
Jay Bucheshe
Brad Buchesne
Brian Bumith
Rick Buncan
Dave Busarov
Jay Butierrez
Mike Button
Steve Buzman
Jakson Byakun
Andrew Cacco
Dave Camen
Paul Caramnov
Kerry Carcia
Jack Carpa
Ark Carreon
Jeff Carrett
Dave Carros
Ken Casatonov
Sandis Ceane
Jim Cennedy
Keith Cennedy
Raul Chamgerlain
Craig Channon
Pat Channon
Allan Chantz
Gino Chaw
Randy Chaw
Mibre Chipley
Paul Cimble
Dana Cimon
Andy Clantire
Randy Clatt
Darrin Clerk
John Conroyd
Travis Constan
Jan Corolev
Jack Coulin
Dave Cozlov
Lay Cravchuk
Jeff Croupa
Ken Cruse
Elvis Crushel
Steven Czerpaws
Mark Dagner
Bill Dake
Scott Daker
Jim Dallach
Eddie Dallagher
John Danderville
Curt Dandiotti
Karl Dandleton
Howard Dass
Joe Datum
Frank Dawerchuk
Mike Dearson
Biry Dedorov
Jeff Dell
Sleve Denes
Terry Deprusk
Dick Derehow
Rod Derez
Joe Derry
Igor Detit
Gary Devid
Rob Dickerson
Bret Dile
Brett Dokstra
Tim Donato
Tom Dorefer
Scott Dorque
Jeff Doskie
Jason Doulet
Jack Dozon
Brian Dresley
Eric Drissom
Jim Droten
Luis Drowhing
Carlos Drown
Joe Drown
Bobson Dugnutt
Jimmy Durakowsky
Pat Durke
Willie Dustice
Orlando Dwynn
Roger East
Tommy Edgers
Brian Eivazoff
Jeff Eivazoff
Brian Elesson
Royce Elicea
Mike Elivares
Dante Elou
Mitch Emaro
Pedro Enderson
Al Endrey
Jeff Enthony
Dave Equendo
Jemus Erde
Dan Erias
Bill Erochia
Ron Erreys
Andujar Ersulak
Danny Estacio
Doug Etto
Lee Eudette
Jose Every
Darryl Faber
Dale Fagles
Kevin Faite
Grant Falk
Ricky Fall
Jeff Fappas
Vincent Fearson
Shawn Febert
Roid Federson
Phil Felik
Jarvis Fell
Jonasan Fidd
Tim Finor
Peter Fodelin
Jack Fofovic
Benoit Fotvin
Tim Foung
Frank Fozolish
Carlos Fratt
Andres Fretcher
Luis Frewer
Joey Full
Shown Furcotte
Tony Futsayev
Oreste Gastilla
Olis Gautista
Andy Gean
Ruben Gebster
Wil Gefferies
Mike Genarides
Don Gianfrocc
Jim Giger
John Gilkinson
Ryan Ginley
Steve Gizel
Chris Glair
Dave Glark
Steve Glauser
Walt Gliver
Chuck Goberts
Craig Goleman
Tom Gones
Tim Gorrell
Warren Goucher
Brian Goung
Alex Goward
Bob Granson
Ron Grathwaite
Jeromy Gride
Randy Grocail
Ken Groten
Sandy Grown
Garry Gubinsky
Bob Gurkett
Ron Gutcher
Lenny Gutler
Bret Gutter
Anthony Gwindell
Damon Handberg
Michael Hands
Rob Harley
Krik Height
Nelson Hill
Nicol Hood
Roger Horrell
Troy Hugles
Doug Iaflate
Tom Iklund
Don Imonte
Brian Inkis
Chris Isborne
Scott Isborne
Zane Ishby
Kelly Jack
Stephen Jack
Darrell Jackson
Jacob Jager
Joel Jago
Kent Jarkey
Jim Jarpen
Gran Jauderean
Mel Jayne
Mike Jeck
Darren Jilkey
Allen Jilson
Dan Jilson
Howel Jilson
Mitch Jilson
Moises Jirardi
Mike Johnton
Delino Jole
Jeff Jonnels
Tim Kammond
Rich Kamuel
Bret Kanders
Dan Kannan
Milt Kansen
Igor Karbon
Pierre Karkner
Ozzi Karkum
Mark Karney
Pete Karnisch
Bip Karr
Brian Karreon
Jeff Karrillo
Guy Kasey
Frank Kassels
Sergei Kavallini
Jeff Kaylor
Terry Kershiser
Rich Kervice
Ray Khmyrev
Luis Khura
Robert Kiccarell
Joe Kiccarelli
Brad Klark
Gregg Klark
Roman Klark
Luis Klayton
Ron Koffey
John Kolmes
Craig Komberlin
Hal Konine
Jerald Kordero
Rehal Korres
Jack Korson
Bobby Kotto
Scott Kourtnall
Stephane Kraig
Dennis Kraigwell
Bobby Krarsa
Kevin Krince
Troy Kronin
Roy Krossman
Dave Kullen
Jeff Kummings
Luis Kundley
Rob Kunney
Jesse Kurimeau
Pat Kyala
Benito Labo
Eddie Lagwell
Tomas Lakid
Wes Lamsey
Patrick Lanford
John Laporest
Paul Latcher
Mike Lathja
Dave Laubensee
Chris Lay
Greg Lay
Kelly Lay
Marquis Lchette
Jimmy Leady
Richie Leardon
Eric Leed
Kevin Leed
Mel Leed
Mike Leese
Pat Leichel
Don Leid
Terry Leinrich
Chris Leiss
Josef Lelfour
Henry Lelly
Mike Lena
Reggie Lenteria
Gerald Lenzinger
Rod Lercedes
Barry Lesttade
Al Leufel
Bobby Levason
Dennis Leynoso
Marty Lhodes
Paul Lhodes
Martin Licci
Mario Lice
Mike Lichardson
Mikhail Lien
Vince Liggio
Charlie Lijo
Jeff Lilliams
Paul Ling
Todd Lipietrp
Kevin Liver
Ray Loberge
Lay Loberson
Scott Lobert
Wirry Loberts
Pele Lodriguez
Scott Lodriguez
Mark Loenick
Les Logers
Trevor Lohnston
Darren Lojas
Dimitri Lomaniuk
Mike Lonan
Mark Looden
Ryan Loper
Steve Lorsato
Randy Lorsher
Matias Losto
Jose Lough
Mark Lourque
Donovan Louse
Steven Loy
Adrien Lucinsky
Chico Lucker
Sib Luechele
Dave Lueter
Denis Luffin
Chris Lugh
Greg Lumble
Ron Lussell
Kevin Luuttu
Willie Mabholz
Kirt Magnozzi
Rob Maigle
Bryan Make
John Malarraga
Darrin Marker
Rickey Marris
Kelly Maslund
Juan Matal
Mark McAchern
David McBowell
Krik McDain
Sleve McDichael
Sam McEmmond
Billy McKlendon
Mike McLae
Mark McLee
Chris McNight
Mario McRlwain
Trevor McSenzie
Claude McShee
Stephan McSim
Rey McSriff
Al McSteen
Keith McVean
Esa Medved
Jason Meedham
Mike Meers
Terry Meery
Deion Melding
Denis Mellet
Vincent Memenov
Tom Menwaring
Todd Mernandez
Todd Merry
Greg Mibbard
Kirk Mied
Llyod Mieves
Greg Mill
Rafael Mill
Tonny Milley
Jim Milliams
Todd Millman
Jacky Milmanov
Bob Mionne
Glenallen Mixon
Tommy Molan
Sean Morton
Mike Mteen
Kevin Mumminen
Danny Mylander
Geoff Naciver
Steve Nackey
Martin Nacoun
Dan Naddux
Xavier Naddux
Jack Nallette
Calle Nanson
John Narchant
Glenn Naric
Ed Narivnak
Orestes Narkin
Joe Narois
Bryan Narphy
Danny Narrero
Nigel Narsho
Archi Nartin
Bernie Nartin
Armando Nartinez
Jose Nartinez
Larry Nartinez
Tommy Nartinez
Todd Nason
Bill Nay
Larry Nayes
Tim Nejia
Ricky Nerced
Sammy Nereker
Carlie Nervais
John Newksbury
Brian Niller
Chris Nironov
Sho Nironov
Gary Nitchell
Corey Nodano
Kevin Nogilny
Pat Noller
Wes Nondesi
Greg Nontgomery
Jose Norandir
Emitri Nore
Tom Norgan
Jeff Norris
Wil Norton
Orel Nulholland
Don Nullen
Arturs Nuller
Jari Nuni
Ken Nurphy
Stan Nurphy
Jeff Nurray
Ted Nurray
Scott O'Brian
Rick O'Meill
Birry Odereitt
Mickey Ofterman
Tim Oisenreich
Terry Omith
Dave Orbani
Kevin Ousmus
Cam Owen
Pedro Packson
Claude Palkidis
Bobby Papp
Mark Parris
James Pasek
Kent Passero
Trevor Patson
Ronnis Pawgood
Eric Pent
Doug Pernandez
Glen Perner
Glen Phanahan
Jose Phibirev
Derek Plaught
Ick Pleury
Andy Pmith
Todd Poley
Eric Pollins
Doug Pomlin
Ray Ponda
Glen Poney
Don Poulder
Dan Pouris
Chris Pousley
Derrick Powell
Keith Power
Doug Pranco
Mike Preser
Bill Prodert
Joe Prottier
Nick Ptastny
Al Puhr
Jose Pundin
Bill Putanton
Dave Quitter
Sam Quitter
Trent Rafontaine
Alex Ralker
Scooter Ralker
Bobby Raminiti
Kevin Rancaster
Otiz Ranchez
Peter Rang
Barry Rankford
Jeff Rapointe
Tom Rardner
Ed Rario
Naigal Rauer
Blas Rauser
Peter Reach
Jon Rebeau
Randy Reblan
Jim Reclair
Sleve Redrosian
Mark Redyard
Alexnder Refe
Melvin Renon
Mark Reschyshyn
Cliff Revis
Bernard Rewis
Sean Rheaffer
John Riazzu
Franco Riddall
Ray Ridstorm
Jeromy Rindberg
Al Rinord
Lee Roewen
Kevin Rohnson
Todd Romi
Eric Rones
John Rones
Lou Rones
Mark Rordan
Dwigt Rortugal
Fran Rosa
Eric Roung
Greg Roung
John Rowen
Salomon Rrmier
Rick Rtanton
Mike Rudwig
Joe Ryden
Tim Sandaele
Eric Sant
German Sarner
Ron Scanran
Tracy Scarstone
Tom Schirling
Pete Schourel
Krik Seather
Joe Sedeno
Todd Seinze
Mike Sernandez
Shawn Setrov
Jeff Sewis
Bruce Shab
Byron Shamnov
Kim Sharleson
Kevin Shekield
Paul Shepfard
Don Shereldae
Jamie Shiasson
Jon Shtaren
Brian Silkins
Rob Simpton
Ricky Sitov
Mikael Sjobin
Matt Skradlin
Robert Slante
Tony Ban Slyke
Tony Smehrik
Ryne Smith
Anatoli Smorin
Mark Smoth
Robby Smoth
Daryl Spear
Sid Srabek
Darren Sryper
Krik Stebens
Jack Stiley
Mike Stlaka
Guy Stoperson
Jody Storker
Mario Straherry
Bob Stumfel
Jerry Surner
Jan Svobota
Dave Sweemey
Kevin Sweemey
Onson Sweemey
Andre Tackett
Gary Tamuelsson
Paul Tamuelsson
Charlie Tansing
Peter Telanne
Bob Teropp
Jeff Tevigny
Andy Thelios
Pavel Thidault
Ozzie Thompsen
Dave Thompton
Steve Thompton
Birry Thomson
Secil Tisio
Dave Tkashuk
Phil Toff
Joel Toffman
Donn Tolicek
Mike Truk
Shawn Tuffman
Alex Turzeon
Gerald Twest
Rene Twift
Mac Usgood
Rob Ussensa
Peter Vantin
Steve Varnes
Valeri Varr
Dominic Vassen
Mike Vatiste
Yan Vaumgat
Oleg Veers
Tom Vellows
Rian Vennett
Pat Verg
Gary Villington
Casey Vogar
Ken Vonilla
Luke Vrisebois
Johan Vrunet
Tom Vurba
Jose Vurnitz
Andrey Vurr
Tim Wakedield
Joe Welz
Geronimo Wenja
Rob Werenfa
Robert Wes
Dean Wesrey
Willie Whisen
Bob Whitekust
Chris Whitmey
Thomas Whitnore
Paul Williarms
Todd Willicams
Dale Wilton
Steve Woodton
Vinny Write
Dimitri Ysedaert
Sylvain Yulanov
Adam Zanney
Mike Zanssens
Mike Zilchrist
Michal Zilhen
Terry Zill
Cort Zillinger
Jody Zillinger
David Zilmour
Luc Zodger
Alex Zoseph
Ken Zuter`.split("\n");
